module.exports = {"511302001":"中城街道","511302002":"北城街道","511302003":"西城街道","511302004":"东南街道","511302005":"舞凤街道","511302006":"新建街道","511302007":"华凤街道","511302008":"和平路街道","511302009":"潆溪街道","511302010":"荆溪街道","511302011":"西山街道","511302012":"搬罾街道","511302104":"共兴镇","511302105":"金台镇","511302106":"芦溪镇","511302107":"李家镇","511302108":"双桥镇","511302114":"渔溪镇","511302200":"新复乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/511302.json
// module id = 2471
// module chunks = 0